import { PropsWithChildren } from 'react'

interface PageProps {
  className?: string
}

export function Page({ children, className }: PropsWithChildren<PageProps>) {
  return <div className={className}>{children}</div>
}
